// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"73e19013","260":"9b03173d","671":"4cb35ba0","884":"97ac380c"}[chunkId] + ".chunk.js";
};